/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { moveStepAgenda } from '../../../app/page/page-storage/agenda-items/agenda-items.actions';
import { agendaItemsPageSelectors } from '../../../app/page/page-storage/agenda-items/agenda-items.selectors';
import { agendaItemSelectors } from '../../../app/resource/agenda-item/agenda-item.selectors';
import { IAgenda } from '../../../app/resource/agenda/agenda.types';
import { IMeetingSimple } from '../../../app/resource/meeting-simple/meeting-simple.types';
import { ISession } from '../../../app/resource/session/session.types';

import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';

import { ConnectedDialog } from '../ConnectedDialog';

import { IAIPreviewDialogProps } from './types';

export const AIPreviewDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'aiPreviewDialog') as IAIPreviewDialogProps;

  const onClose = useCallback(() => {
    dispatch(closeDialog('aiPreviewDialog'));
  }, [dispatch]);

  const ai = useSelect(agendaItemsPageSelectors.selectAgendaItems);
  let data: string[] = [];
  if (props) {
    data = ai[props.meetingId];
  }

  const agendaItemsSelected = useSelectWithParams(agendaItemSelectors.selectResourcesById, data) as IAgenda[];

  const agendaItems = agendaItemsSelected.filter((item) => item.checked === '1');

  const history = useHistory();
  const goToAgendaItem = useCallback(
    (index: number) => {
      const [, , mId, sesId] = history.location.pathname.split('/');
      const meetingId = mId as IMeetingSimple['id'];
      const sessionId = sesId as ISession['id'];
      dispatch(moveStepAgenda({ meetingId, sessionId, index: `${index}` }));
    },
    [dispatch, history],
  );

  return (
    <ConnectedDialog dialogKey="aiPreviewDialog">
      <div className="popup agenda_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Agenda</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body p-2">
            {agendaItems.map(
              (ai, index) =>
                ai && (
                  <a
                    className="panel flex aic px-1 mb-1 close"
                    style={{ margin: 'auto', userSelect: 'none', cursor: 'pointer' }}
                    title=""
                    onClick={() => {
                      goToAgendaItem(index);
                      dispatch(closeDialog('aiPreviewDialog'));
                    }}
                    key={ai.id}
                  >
                    {ai.title} <span className="ml-auto blueGray">{ai.duration} min</span>
                  </a>
                ),
            )}
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
